import { render } from "./NestedModifier.vue?vue&type=template&id=350b3f49&scoped=true"
import script from "./NestedModifier.vue?vue&type=script&lang=js"
export * from "./NestedModifier.vue?vue&type=script&lang=js"

import "./NestedModifier.vue?vue&type=style&index=0&id=350b3f49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350b3f49"]])

export default __exports__